import { motion } from "framer-motion";
import React from "react";
import { BodyText, SaveButton } from "../../styles/global";
import { LeftSection, RightSection } from "../header/Header.style";
import {
  WrapperHero,
  TitleText,
  ButtonWrapper,
  InvestImage,
} from "./Hero.styles";

export const HeroSectionThree = () => {
  return (
    <>
      <WrapperHero>
        <LeftSection>
          <TitleText>
            <div>Sublime investment Packages that builds you a fortune</div>
            <BodyText>
              Our investment opportunities are made simple and worth it, to
              match your financial standing and gradually help you start
              accruing wealth from one stage of the investment plans to another.
            </BodyText>
          </TitleText>
          <ButtonWrapper>
            <SaveButton to="/">Start Investment</SaveButton>
          </ButtonWrapper>
        </LeftSection>

        <RightSection>
          <motion.div>
            <InvestImage src="img/rafiki.jpg" alt="" />
          </motion.div>
        </RightSection>
      </WrapperHero>
    </>
  );
};
